import { observable, action } from "mobx";
import agent from "../agent";

const defaultAdminStats = {
    totalArtists: 0,
    newArtists: 0,
    totalActs: 0,
    newActs: 0,
    totalAgents: 0,
    newAgents: 0,
    totalVenues: 0,
    newVenues: 0,
    totalGigs: 0,
    newGigs: 0,
    completedGigs: 0,
    totalBookingValue: 0,
    newBookingValue: 0,
    completedBookingValue: 0
};

const defaultActsStats = {
    totalArtists: 0,
    newArtists: 0,
    existingArtists: 0,
    totalActs: 0,
    newActs: 0,
    existingActs: 0,
    recentArtists: []
};

const defaultBookingsStats = {
    totalGigs: 0,
    newGigs: 0,
    completedGigs: 0,
    historicalGigs: 0,
    totalValue: 0,
    newValue: 0,
    completedValue: 0,
    historicalValue: 0
};

const defaultVenuesStats = {
    totalVenues: 0,
    newVenues: 0,
    existingVenues: 0,
    totalAgents: 0,
    newAgents: 0,
    existingAgents: 0
};

class AdminStore {
    @observable adminStats = { ...defaultAdminStats };
    @observable actsStats = { ...defaultActsStats };
    @observable bookingsStats = { ...defaultBookingsStats };
    @observable venuesStats = { ...defaultVenuesStats };

    @action
    getAdminStats = async (startDate, endDate) => {
        try {
            const response = await agent.Admin.getStats(startDate, endDate);
            if (response) {
                this.adminStats = { ...defaultAdminStats, ...response };
            }
            return this.adminStats;
        } catch (error) {
            console.error("Error fetching admin stats:", error);
            this.adminStats = { ...defaultAdminStats };
            return this.adminStats;
        }
    };

    @action
    getActsStats = async (startDate, endDate) => {
        try {
            const response = await agent.Admin.getActsStats(startDate, endDate);
            if (response) {
                this.actsStats = { 
                    ...defaultActsStats, 
                    ...response,
                    recentArtists: Array.isArray(response.recentArtists) ? response.recentArtists : []
                };
            }
            return this.actsStats;
        } catch (error) {
            console.error("Error fetching acts stats:", error);
            this.actsStats = { ...defaultActsStats };
            return this.actsStats;
        }
    };

    @action
    getBookingsStats = async (startDate, endDate) => {
        try {
            const response = await agent.Admin.getBookingsStats(startDate, endDate);
            if (response) {
                this.bookingsStats = { ...defaultBookingsStats, ...response };
            }
            return this.bookingsStats;
        } catch (error) {
            console.error("Error fetching bookings stats:", error);
            this.bookingsStats = { ...defaultBookingsStats };
            return this.bookingsStats;
        }
    };

    @action
    getVenuesStats = async (startDate, endDate) => {
        try {
            const response = await agent.Admin.getVenuesStats(startDate, endDate);
            if (response) {
                this.venuesStats = { ...defaultVenuesStats, ...response };
            }
            return this.venuesStats;
        } catch (error) {
            console.error("Error fetching venues stats:", error);
            this.venuesStats = { ...defaultVenuesStats };
            return this.venuesStats;
        }
    };
}

export default new AdminStore();
